export const AMEBA = {
  ROW: 3997,
  USA: 3666,
};

export const LINK = {
  ROW: {
    633: 3869,
    634: 4006,
  },
  USA: 4059,
};

export const LINK_XXL = {
  ROW: 4006,
  USA: 4059,
};

export const FOLD_SURFACE = {
  ROW: 4060,
  USA: 4086,
};

export const ORIGAMI = {
  ROW: 4075,
  USA: 4089,
};

export const PUCK_WALL_ART = {
  ROW: 4065,
  USA: 4091,
};

export const SET = {
  ROW: 4155,
  USA: 4816,
};

export const STICKS = {
  ROW: 5025,
  USA: 5037,
};

export const ALGORITHM = {
  ROW: 4994,
  USA: 5003,
};

export const MATCH = {
  ROW: 4100,
  USA: 4905,
};

export const TUBE = {
  ROW: 5014,
  USA: 5024,
};

export const WIREFLOW = {
  ROW: 4160,
  USA: 4767,
};

export const RHYTHM = {
  ROW: 4108,
  USA: 4092,
};

export const HALO = {
  ROW: 4993,
  USA: 4992,
};

export const PLUSMINUS = {
  ROW: 5031,
  USA: 5044,
};

export const RHYTHM_VERTICAL = {
  SUBFAMILY_ID: 149,
};

export const RHYTHM_HORIZONTAL = {
  SUBFAMILY_ID: 148,
};

export const WIREFLOW_CHANDELIER = {
  SUBFAMILY_ID: 183,
};

export const WIREFLOW_FREE_FORM = {
  SUBFAMILY_ID: 184,
};

export const WIREFLOW_LINEAL = {
  SUBFAMILY_ID: 185,
};

export const HALO_CIRCULAR = {
  SUBFAMILY_ID: 69,
};

export const HALO_LINEAL = {
  SUBFAMILY_ID: 70,
};

export const STICKS_SOLO = {
  SUBFAMILY_ID: 247,
}

export const PLUSMINUS_SOLO = {
  SUBFAMILY_ID: 246,
}

export enum CATEGORIES {
  REGULAR = 1,
  SPECIFIC_PLAYER = 2,
  MODULAR = 3,
  LG2 = 4,
  VIRTUAL = 5,
  TOOLKIT = 6,
}

export enum PRODUCT_TYPE {
  CREATION = 'CREATION',
  REGULAR = 'REGULAR',
}

export const UMBRELLA_MODEL_CODE = {
  AMEBA: '0001',
  HALO_CIRCULAR: '0002',
  MATCH: '0003',
  RHYTHM_HORIZONTAL: '0004',
  LINK_XXL: '0005',
  LINK: '0006',
  FOLD_SURFACE: '0007',
  ORIGAMI: '0008',
  HALO_LINEAL: '0012',
  WIREFLOW_LINEAL: '0013',
  SET: '0014',
  RHYTHM_VERTICAL: '0015',
  ALGORITHM: '0017',
  WIREFLOW: '0018',
  WIREFLOW_FREE_FORM: '0019',
  WIREFLOW_CHANDELIER: '0020',
  TUBE: '0021',
  PUCK: '0023',
  PUCK_USA: '0024',
  STICKS: '0025',
  PLUSMINUS: '0026',
};

export const TUBE_SHADE_TYPE_ID = 3;
